import React from 'react'
import Card, { getCardDimensions } from './card'

/**
 * @param table
 * @param playerPositions
 * @param parentWidth
 * @param parentHeight
 * @param isPlaying
 */
class Trick extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            animateMoveToPlayer: undefined
        }
    }

    componentWillReceiveProps(nextProps)
    {
        if (nextProps.table.get("_trickWinningPlayerId"))
        {
            setTimeout(() => {
                this.setState({
                    animateMoveToPlayer: Array.from(this.props.playerPositions.entries())
                        .find(e => e[1].get("id") == nextProps.table.get("_trickWinningPlayerId"))[0]
                })
            }, this.shouldUseFastAnimations(nextProps.table) ? 500 : 2000)
        }
        else if (this.state.animateMoveToPlayer)
        {
            this.setState({ animateMoveToPlayer: undefined })
        }
    }

    shouldUseFastAnimations(table)
    {
        return table.getIn(["timeLimit", "base"]) > -1
    }

    render()
    {
        const t = this.props.table
        const cardDims = getCardDimensions(this.props.parentWidth, this.props.parentHeight)

        const rotations = [ 0, 20, -25, 40 ]
        const translations = [
            [ 0, -cardDims.height * .2 ], [ 0.22 * cardDims.height, 0.17 * cardDims.height ],
            [ -cardDims.height * .11, .18 * cardDims.height ], [ .18 * -cardDims.height, .3 * cardDims.height ]
        ]
        const cards = t.get("currentTrick").map((c, idx) => {
            let position = Array.from(this.props.playerPositions.entries())
                .find(e => e[1].get("turnIdx") == idx)
            let player = null
            if (position != null) {
                player = position[1]
                position = position[0]
            }
            return (
                <Card
                    key={ idx }
                    cardId={ c }
                    size="trick"
                    className={ (position && (!this.props.isPlaying || position !== "bot") ? ("player-" + position) : "") + " played-by-" + (player ? player.get("color").toLowerCase() : "") }
                    style={{
                        transform: "translate(" + translations[idx][0] + "px," + translations[idx][1] + "px) rotate(" + rotations[idx] + "deg)",
                        borderRadius: 0.06 * cardDims.height,
                        ...cardDims
                    }}
                />
            )
        })

        let className = "table-trick "
            + (this.state.animateMoveToPlayer ? ("move-to-" + this.state.animateMoveToPlayer) : "")
            + (this.shouldUseFastAnimations(t) ? " fast " : "")

        return (
            <div className="table-trick-container">
                <div
                    ref={ ref => {
                        if (ref) {
                            const rect = ref.getBoundingClientRect()
                            window.__trickDisplay = {
                                x: rect.x,
                                y: rect.y,
                                rotations: rotations,
                                translations: translations
                            }
                        }
                    } }
                    className={ className }
                    style={{ ...cardDims }}>
                    { cards }
                </div>
            </div>
        )
    }

}

export default Trick
export { Trick }